import React from "react";
import PropTypes from "prop-types";

const HttpRequestTracker = ({ status, response, error, metrics }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: 350,
        maxHeight: 350,
        minHeight: 200,
      }}
    >
      {status === "idle" && (
        <div className="has-text-grey">No request sent yet.</div>
      )}
      {status === "loading" && (
        <div
          className="has-text-centered"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            className="loader is-loading"
            style={{ width: 30, height: 30, margin: "0 auto" }}
          ></div>
          <div>Sending request...</div>
        </div>
      )}
      {status === "success" && response && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <div className="mb-3">
            <span className="tag is-success is-medium">Success</span>
          </div>

          <div
            style={{
              background: "#f6f8fa",
              maxWidth: 650,
              borderRadius: 8,
              padding: 16,
            }}
          >
            <pre style={{ margin: 0, fontSize: 14 }}>
              {JSON.stringify(response, null, 2)}
            </pre>
          </div>
        </div>
      )}
      {status === "error" && error && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
          }}
        >
          <div className="mb-3">
            <span className="tag is-danger is-medium">Error</span>
          </div>
          <div
            style={{
              flex: 1,
              minHeight: 0,
              maxHeight: 200,
              overflow: "auto",
              background: "#fff0f0",
              borderRadius: 8,
              padding: 16,
            }}
          >
            <pre style={{ margin: 0, fontSize: 14, color: "#b71c1c" }}>
              {typeof error === "string"
                ? error
                : JSON.stringify(error, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

HttpRequestTracker.propTypes = {
  status: PropTypes.string.isRequired,
  response: PropTypes.object,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  metrics: PropTypes.arrayOf(PropTypes.string),
};

HttpRequestTracker.defaultProps = {
  response: null,
  error: null,
  metrics: [],
};

export default HttpRequestTracker;
